import { Box, Image } from '@chakra-ui/react';
import VMaterialIcon from '@voly/ui-components/src/v2/icons/VMaterialIcon.jsx';
import { ReactElement } from 'react';
import { TCustomField } from 'src/app/project/modules/custom-fields/custom-fields.model';
import { getCustomFieldIconPath, getCustomFieldMaterialIcon } from '../../../utils/customFieldType';

type TCustomFieldTypeIconSize = 'sm' | 'md';

const BOX_SIZE: Record<TCustomFieldTypeIconSize, number> = {
  sm: 4,
  md: 6,
};

interface CustomFieldTypeIconProps {
  field: TCustomField;
  size: TCustomFieldTypeIconSize;
}

const CustomFieldTypeIcon = ({ field, size }: CustomFieldTypeIconProps): ReactElement => {
  const materialIcon = getCustomFieldMaterialIcon(field);
  const integrationIconPath = getCustomFieldIconPath(field);

  return (
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      boxSize={BOX_SIZE[size]}
      flexShrink={0}
      aria-hidden="true"
      data-testid="field-type-icon"
    >
      {materialIcon ? (
        <VMaterialIcon pack="" name={materialIcon} size={size} />
      ) : (
        <Image alt="" src={integrationIconPath ?? undefined} boxSize="100%" />
      )}
    </Box>
  );
};

export default CustomFieldTypeIcon;
